import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import {useState} from "react";
import {Link} from "react-router-dom";
import "./Styles/ResponsiveAppBar.css"
import CssBaseline from "@mui/material/CssBaseline";
import {useMediaQuery} from "@mui/material";

const pages = ['Schedule','Competition Info', 'Sponsors', 'Artists', 'Papers'];
const title = "Third Altenburg International Baroque Trumpet Competition"
const shortTitle = "Altenburg Competition"
const shortestTitle = "Altenburg Competition"

function ResponsiveAppBar(props) {
    const [anchorElNav, setAnchorElNav] = useState(null);
    const matches = useMediaQuery('(max-width:1200px)');
    const matchesPhone = useMediaQuery('(max-width:450px');
    let finalTitle = title

    if (matches)
        finalTitle = shortTitle
    if (matchesPhone)
        finalTitle = shortestTitle

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    return (
        <Box sx={{display: 'flex'}}>
        <CssBaseline/>
        <AppBar position="static" sx={{backgroundColor: props.backgroundColor, color: 'inherit'}}>
            <Container maxWidth="xl" disableGutters={false}>
                <Toolbar>
                    <Typography
                        variant="h6"
                        noWrap
                        href="/"
                        sx={{
                            mr: 2,
                            display: { xs: 'none', md: 'flex' },
                            color: 'inherit',
                            textDecoration: 'none',
                            flexGrow: 1
                        }}
                    >
                        <Link to={'/'} className='title'>
                            {finalTitle}
                        </Link>
                    </Typography>

                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="#fff !important"
                        >
                            <MenuIcon id={'menu-icon'}/>
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                            }}
                        >
                            <Link
                                to={'https://forms.gle/TcNW1GSDVrt3fzw67'}
                                target="_blank"
                                rel="noopener noreferrer"
                                className='dropdown-link'
                            >
                                <MenuItem onClick={handleCloseNavMenu}>
                                    <Typography textAlign="center" sx={{ color: 'secondary', fontWeight: 'bold' }}>
                                        Register
                                    </Typography>
                                </MenuItem>
                            </Link>
                            {pages.map((page) => (
                                <Link key={page} to={'/' + page.replace(/\s/g, "")} className='dropdown-link'>
                                <MenuItem key={page} onClick={handleCloseNavMenu}>
                                    <Typography textAlign="center">
                                            {page}
                                    </Typography>
                                </MenuItem>
                                </Link>
                            ))}
                        </Menu>
                    </Box>

                    <Typography
                        variant="h6"
                        noWrap
                        href="/"
                        sx={{
                            mr: 2,
                            display: { xs: 'flex', md: 'none' },
                            flexGrow: 1,
                            color: 'inherit',
                            textDecoration: 'none',
                        }}
                    >
                        <Link to={'/'} className='title'>
                            {finalTitle}
                        </Link>
                    </Typography>

                    <Box sx={{ flexGrow: 0, display: { xs: 'none', md: 'flex' } }}>
                        {/*<Link*/}
                        {/*    to={'https://forms.gle/TcNW1GSDVrt3fzw67'}*/}
                        {/*    target="_blank"*/}
                        {/*    rel="noopener noreferrer"*/}
                        {/*    className='text-link'*/}
                        {/*>*/}
                        {/*    <Button*/}
                        {/*        variant="contained"*/}
                        {/*        color="secondary"*/}
                        {/*        onClick={handleCloseNavMenu}*/}
                        {/*        sx={{*/}
                        {/*            my: 2,*/}
                        {/*            mr: 1,*/}
                        {/*            fontSize: 'medium',*/}
                        {/*            textTransform: 'none'*/}
                        {/*        }}*/}
                        {/*    >*/}
                        {/*        REGISTER*/}
                        {/*    </Button>*/}
                        {/*</Link>*/}
                        {pages.map((page) => (
                            <Link key={page} to={'/' + page.replace(/\s/g, "")} className='text-link'>
                                <Button
                                    onClick={handleCloseNavMenu}
                                    sx={{ my: 2, color: 'white', display: 'block', fontSize: 'medium' }}
                                >
                                    {page}
                                </Button>
                            </Link>
                        ))}
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
        </Box>
    );
}
export default ResponsiveAppBar;